import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { useClient } from './ClientContext';
interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function SuccessModal({
  isOpen,
  onClose
}: SuccessModalProps) {
  const {
    clientName
  } = useClient();
  const firstName = clientName.split(' ')[0] || 'Gurj';
  return <AnimatePresence data-id="element-271">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-272">
          <motion.div key="backdrop" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="absolute inset-0 bg-black/90 backdrop-blur-sm" data-id="element-273" />
          <motion.div key="modal" initial={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} animate={{
        scale: 1,
        opacity: 1,
        y: 0
      }} exit={{
        scale: 0.95,
        opacity: 0,
        y: 20
      }} className="relative w-full max-w-md bg-surface border border-white/[0.1] p-12 text-center overflow-hidden" data-id="element-274">
            <button onClick={onClose} className="absolute top-6 right-6 p-2 text-zinc-500 hover:text-white transition-colors" data-id="element-275">
              <XIcon className="w-5 h-5" data-id="element-276" />
            </button>
            <div className="mx-auto w-16 h-16 border border-emerald-500/30 bg-emerald-500/10 flex items-center justify-center mb-8" data-id="element-277">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            delay: 0.2,
            type: 'spring'
          }} data-id="element-278">
                <CheckIcon className="w-8 h-8 text-emerald-400" data-id="element-279" />
              </motion.div>
            </div>
            <h3 className="text-3xl font-black text-white uppercase tracking-tight mb-4" data-id="element-280">
              Signed
            </h3>
            <p className="text-zinc-400 mb-8 font-light leading-relaxed" data-id="element-281">
              Thank you, {firstName}. Your proposal has been submitted
              successfully. We're excited to start this journey with you and
              we'll be in touch shortly.
            </p>
            <button onClick={onClose} className="w-full py-4 px-6 bg-white text-black font-bold uppercase tracking-widest text-xs hover:bg-zinc-200 transition-colors" data-id="element-282">
              Close
            </button>
          </motion.div>
        </div>}
    </AnimatePresence>;
}